module.exports = [
	{ 'xs': 0 },
	{ 'sm' : 480 },
	{ 'md' : 736 },
	{ 'lg' : 980 },
	{ 'xl' : 1280 },
	{ '2xl' : 1536 },
	{ '3xl' : 1920 }
]